import React, { useEffect, useRef } from 'react';
import './Modal.scss';

export default function Modal({
  children,
  hideCloseButton,
  showPopup,
  togglePopupFn,
  theme,
  version,
}) {
  const modalContentRef = useRef(null);
  const modalContainerRef = useRef(null);

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => (document.body.style.overflow = 'unset');
  }, [showPopup]);

  function handleCloseModal(closeInternally) {
    if (!hideCloseButton || closeInternally === 'close') {
      modalContentRef.current.classList.add('closing');
      modalContainerRef.current.classList.add('closing');
    }
  }

  function addScrollVisible() {
    modalContentRef.current.classList.add('scroll_visible');
  }

  function removeScrollVisible() {
    modalContentRef.current.classList.remove('scroll_visible');
  }

  const additionalProps = {
    handleCloseModal,
    addScrollVisible,
    removeScrollVisible,
  };

  // Render children with additional props
  const childrenWithProps = React.Children.map(children, (child) => {
    // Clone the child element and pass additional props
    return React.cloneElement(child, additionalProps);
  });

  function finishClosingModal(e) {
    if (e.animationName === 'pop-out') {
      togglePopupFn && togglePopupFn();
    }
  }

  if (!showPopup) {
    return null;
  }
  return (
    <div className={`modal ${theme}`} ref={modalContainerRef} onClick={handleCloseModal}>
      <div
        className={`modal_content ${theme} ${version}`}
        ref={modalContentRef}
        onAnimationEnd={finishClosingModal}
        onClick={(e) => e.stopPropagation()}
        data-testid="modal_content">
        {!hideCloseButton ? (
          <button
            type="button"
            aria-label="close modal"
            className="modal_close"
            onClick={handleCloseModal}>
            <span className="icon-close icon" />
          </button>
        ) : null}
        <div className="modal_body">{childrenWithProps}</div>
      </div>
    </div>
  );
}
